/// <reference types="react" />
import React = require("react");
import ReactDOM = require("react-dom");
import { Dialog } from "VSSUI/Dialog";
import Resources = require("DistributedTask/Scripts/Resources/TFS.Resources.DistributedTask");
import { LibraryActionCreator } from "DistributedTask/Scripts/Actions/LibraryActionCreator";
import * as Utils_String from "VSS/Utils/String";

export interface IDeleteConfirmationDialogProps {
    id: number;
    showDialog: (value: boolean) => void;
}

export default class DeleteDialog {

    public static renderVariableGroupsDeleteDialog(variableGroupId: string, updateShowVariableGroupsDeleteDialogValue: any): React.ReactNode {
        let helpText = Resources.DeleteVariableGroupHelpText.split('<br/>');

        return (
            <Dialog
                titleProps={{ text: Resources.DeleteVariableGroup }}
                onDismiss={() => { updateShowVariableGroupsDeleteDialogValue(false); }}
                footerButtonProps={[
                    {
                        text: Resources.DeleteText,
                        primary: true,
                        onClick: () => {
                            LibraryActionCreator.getInstance().deleteVariableGroup(Number(variableGroupId));
                            updateShowVariableGroupsDeleteDialogValue(false);
                        }
                    },
                    {
                        text: Resources.CancelText,
                        onClick: () => {
                            updateShowVariableGroupsDeleteDialogValue(false);
                        }
                    }
                ]}

            >
                {
                    helpText[0] &&
                    <div>
                        {helpText[0]}
                    </div>
                }
                {
                    helpText[1] &&
                    < div >
                        {helpText[1]}
                    </div>
                }
            </Dialog>
        )
    }

    public static renderSecureFilesDeleteDialog(secureFileId: string, updateShowSecureFilesDeleteDialogValue: any): React.ReactNode {
        let helpText = Resources.DeleteSecureFileHelpText.split('<br/>');

        return (
            <Dialog
                titleProps={{ text: Resources.DeleteSecureFile }}
                onDismiss={() => { updateShowSecureFilesDeleteDialogValue(false); }}
                footerButtonProps={[
                    {
                        text: Resources.DeleteText,
                        primary: true,
                        onClick: () => {
                            LibraryActionCreator.getInstance().deleteSecureFile(secureFileId);
                            updateShowSecureFilesDeleteDialogValue(false);
                        }
                    },
                    {
                        text: Resources.CancelText,
                        onClick: () => {
                            updateShowSecureFilesDeleteDialogValue(false);
                        }
                    }
                ]}

            >
                <div>
                    {helpText[0]}
                </div>
                <div>
                    {helpText[1]}
                </div>
            </Dialog>
        )
    }

    public static renderOauthConfigurationDeleteDialog(configurationName: string, updateShowOAuthConfigurationDeleteDialogValue: any, callback: () => void): React.ReactNode {
        let helpText = Utils_String.localeFormat(Resources.DeleteOAuthConfigurationHelpText, Utils_String.htmlEncode(configurationName))

        return (
            <Dialog
                titleProps={{ text: Resources.DeleteOAuthConfiguration }}
                onDismiss={() => { updateShowOAuthConfigurationDeleteDialogValue(false); }}
                footerButtonProps={[
                    {
                        text: Resources.DeleteText,
                        primary: true,
                        onClick: () => {
                            callback();
                            updateShowOAuthConfigurationDeleteDialogValue(false);
                        }
                    },
                    {
                        text: Resources.CancelText,
                        onClick: () => {
                            updateShowOAuthConfigurationDeleteDialogValue(false);
                        }
                    }
                ]}

            >
                <div>
                    {helpText}
                </div>
            </Dialog>
        )
    }

}
